<div class="table-container" [class.row-selection-enabled]="enableRowSelection">
  <button
    class="hidden-export-button"
    (click)="exportTable('csv')"
    id="table-upload-csv"
  ></button>
  <button
    class="hidden-export-button"
    (click)="exportTable('pdf')"
    id="table-upload-pdf"
  ></button>
  <table>
    <colgroup>
      <col
        *ngIf="enableRowSelection"
        style="width: 56px; min-width: 56px; max-width: 56px"
      />
      <ng-container *ngFor="let col of columns; let i = index">
        <col *ngIf="columns.length <= 8" />
        <col *ngIf="columns.length > 8" />
      </ng-container>
      <col
        *ngIf="actionTemplate"
        class="mat-column-actions"
        style="width: 110px; min-width: 110px; max-width: 110px"
      />
    </colgroup>

    <thead>
      <tr>
        <th *ngIf="enableRowSelection">
          <input
            type="checkbox"
            [checked]="selectAllChecked"
            (change)="toggleSelectAll()"
          />
        </th>
        <th
          *ngFor="let col of columns"
          class="sortable-th"
          [class.status-column]="
            col === 'status' ||
            col === 'registrationStatus' ||
            col === 'attendanceStatus'
          "
          [class.mat-column-status]="
            col === 'status' ||
            col === 'registrationStatus' ||
            col === 'attendanceStatus'
          "
        >
          <div
            class="header-content"
            [class.status-header]="
              col === 'status' ||
              col === 'registrationStatus' ||
              col === 'attendanceStatus'
            "
          >
            <span class="header-label">{{ formatColumnHeader(col) }}</span>
            <button
              class="sort-btn"
              [class.asc]="getSortState(col) === 'asc'"
              [class.desc]="getSortState(col) === 'desc'"
              (click)="cycleSort(col)"
              type="button"
              [attr.aria-label]="'Sort ' + formatColumnHeader(col)"
            >
              <img
                class="sort-image"
                [src]="getSortImage(getSortState(col))"
                alt="Sort"
              />
            </button>
          </div>
        </th>
        <th *ngIf="actionTemplate" class="actions-header mat-column-actions">
          {{ actionButtonName || "Actions" }}
        </th>
      </tr>
    </thead>

    <tbody
      *ngIf="!loading"
      [class.fade-out]="isAnimating"
      [class.fade-in]="!isAnimating"
    >
      <tr
        *ngFor="let row of paginatedData; let i = index"
        [class.invalid-row]="!isRowValid(row) && enableRowSelection"
        (click)="onRowClick(row, $event)"
        [class.clickable-row]="
          rowClick.observers.length > 0 && !row.isDownloading
        "
        [class.downloading-row]="row.isDownloading"
      >
        <td *ngIf="enableRowSelection">
          <input
            type="checkbox"
            [checked]="isRowSelected(row)"
            (change)="toggleRowSelection(row)"
            [disabled]="!isRowValid(row)"
            [class.invalid-checkbox]="!isRowValid(row)"
            matTooltip="Invalid email or phone number"
            [matTooltipDisabled]="isRowValid(row)"
          />
        </td>

        <td
          *ngFor="let col of columns; let colIndex = index"
          [class.status-column]="
            col === 'status' ||
            col === 'registrationStatus' ||
            col === 'attendanceStatus'
          "
          [class.mat-column-status]="
            col === 'status' ||
            col === 'registrationStatus' ||
            col === 'attendanceStatus'
          "
          [class.merged-cell]="shouldMergeCell(row, col, colIndex)"
        >
          <!-- School name column - handle separately -->
          <ng-container *ngIf="col === 'school name'">
            <span *ngIf="!shouldMergeCell(row, col, colIndex)">
              {{ row[col] ?? "-" }}
            </span>
          </ng-container>

          <!-- All other columns -->
          <ng-container *ngIf="col !== 'school name'">
            <ng-container [ngSwitch]="col">
              <ng-container *ngSwitchCase="'status'">
                <span
                  [ngClass]="
                    row.status === 'TeacherReviewPending' ||
                    row.status === 'Pending' ||
                    row.status === 'Interested'
                      ? 'status-interested'
                      : row.status === 'TeacherApproved' ||
                          row.status === 'Teacher Approved' ||
                          row.status === 'AdminApproved'
                        ? 'status-approved'
                        : row.status === 'TeacherRejected' ||
                            row.status === 'AdminRejected'
                          ? 'status-unapproved'
                          : row.status === 'Approved'
                            ? 'status-active'
                            : row.status === 'Rejected'
                              ? 'status-inactive'
                              : row.status === 'Unregistered' ||
                                  row.status === 'Not Registered'
                                ? 'status-upcoming'
                                : row.status === 'Active'
                                  ? 'status-active'
                                  : row.status === 'Inactive'
                                    ? 'status-inactive'
                                    : row.status === 'Already Held'
                                      ? 'status-already-held'
                                      : row.status === 'Upcoming'
                                        ? 'status-upcoming'
                                        : row.status === 'On Hold'
                                          ? 'status-inactive'
                                          : row.status === 'Ongoing'
                                            ? 'status-active'
                                            : row.status === 'Registered'
                                              ? 'reg-status'
                                              : row.status === 'Attended'
                                                ? 'reg-status'
                                                : row.status ===
                                                    'UnregisteredAddedManually'
                                                  ? 'status-active'
                                                  : row.status ===
                                                      'NewNonOnboarded'
                                                    ? 'status-active'
                                                    : 'status-pending'
                  "
                  (click)="
                    row.status === 'TeacherApproved' ||
                    row.status === 'Registered' ||
                    row.status === 'TeacherRejected' ||
                    row.status === 'UnregisteredAddedManually' ||
                    row.status === 'NewNonOnboarded'
                      ? ''
                      : onStatusClick(row, $event)
                  "
                  [ngStyle]="{
                    cursor: row?.isStatusClickable ? 'pointer' : 'default',
                  }"
                >
                  {{
                    row.status === "TeacherApproved" ||
                    row.status === "AdminApproved"
                      ? "Approved"
                      : row.status === "TeacherReviewPending" ||
                          row.status === "Pending" ||
                          row.status === "Interested"
                        ? "Interested"
                        : row.status === "TeacherRejected" ||
                            row.status === "AdminRejected"
                          ? "Unapproved"
                          : row.status === "UnregisteredAddedManually"
                            ? "Unregistered Added Manually"
                            : row.status === "NewNonOnboarded"
                              ? "New Non Onboarded"
                              : row.status === "PreRegistered"
                                ? "Pre Registered"
                                : row.status === "ConsentDeclined"
                                  ? "Parent Declined"
                                  : row.status === "Rejected"
                                    ? "Declined"
                                    : row.status
                  }}
                </span>
              </ng-container>

              <ng-container *ngSwitchCase="'event status'">
                <ng-container *ngIf="allowEventStatusChange; else staticEventStatus">
                  <div class="status-label-dropdown-wrapper">
                    <span
                      [ngClass]="row['event status'] === 'Approved' ? 'status-approved' :
                                 row['event status'] === 'Unapproved' ? 'status-unapproved' : 'status-interested'"
                      class="status-label-badge"
                      (click)="toggleEventStatusDropdown(row, $event)"
                    >
                      {{ row['event status'] }}
                      <svg width="10" height="6" viewBox="0 0 10 6" fill="none" style="flex-shrink:0">
                        <path d="M1 1L5 5L9 1" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                      </svg>
                    </span>
                    <div class="status-label-dropdown" *ngIf="openEventStatusDropdownRowId === row.id">
                      <div class="status-label-item interested-item"
                           *ngIf="row['event status'] !== 'Interested'"
                           (click)="selectEventStatus(row, 'Interested', $event)">Interested</div>
                      <div class="status-label-item approved-item"
                           *ngIf="row['event status'] !== 'Approved'"
                           (click)="selectEventStatus(row, 'Approved', $event)">Approved</div>
                      <div class="status-label-item unapproved-item"
                           *ngIf="row['event status'] !== 'Unapproved'"
                           (click)="selectEventStatus(row, 'Unapproved', $event)">Unapproved</div>
                    </div>
                  </div>
                </ng-container>
                <ng-template #staticEventStatus>
                  <span
                    [ngClass]="
                      row['event status'] === 'TeacherReviewPending' ||
                      row['event status'] === 'Pending' ||
                      row['event status'] === 'NewNonOnboarded' ||
                      row['event status'] === 'Interested'
                        ? 'status-interested'
                        : row['event status'] === 'TeacherApproved' ||
                            row['event status'] === 'Teacher Approved' ||
                            row['event status'] === 'AdminApproved' ||
                            row['event status'] === 'Approved'
                          ? 'status-approved'
                          : row['event status'] === 'TeacherRejected' ||
                              row['event status'] === 'AdminRejected' ||
                              row['event status'] === 'Unapproved'
                            ? 'status-unapproved'
                            : 'status-pending'
                    "
                    [ngStyle]="{ cursor: row?.isStatusClickable ? 'pointer' : 'default' }"
                    (click)="row?.isStatusClickable ? onStatusClick(row, $event) : null"
                  >
                    {{
                      row['event status'] === 'TeacherApproved' || row['event status'] === 'AdminApproved'
                        ? 'Approved'
                        : row['event status'] === 'TeacherReviewPending' ||
                            row['event status'] === 'Pending' ||
                            row['event status'] === 'NewNonOnboarded' ||
                            row['event status'] === 'Interested'
                          ? 'Interested'
                          : row['event status'] === 'TeacherRejected' || row['event status'] === 'AdminRejected'
                            ? 'Unapproved'
                            : row['event status']
                    }}
                  </span>
                </ng-template>
              </ng-container>

              <ng-container *ngSwitchCase="'registrationStatus'">
                <span
                  [ngClass]="
                    row.registrationStatus === 'Registered'
                      ? 'reg-success'
                      : row.registrationStatus === 'Not Registered'
                        ? 'reg-inavalid'
                        : 'status-pending'
                  "
                  (click)="onStatusClick(row, $event)"
                >
                  {{ row.registrationStatus }}
                </span>
              </ng-container>

              <ng-container *ngSwitchCase="'attendanceStatus'">
                <span
                  [ngClass]="
                    row.attendanceStatus === 'Present'
                      ? 'status-active'
                      : row.attendanceStatus === 'Absent'
                        ? 'status-inactive'
                        : 'status-pending'
                  "
                  (click)="onStatusClick(row, $event)"
                >
                  {{ row.attendanceStatus }}
                </span>
              </ng-container>

              <ng-container *ngSwitchCase="'admin approval'">
                <span
                  [ngClass]="
                    row['admin approval'] === 'Pending'
                      ? 'status-pending'
                      : row['admin approval'] === 'Approved'
                        ? 'status-active'
                        : 'status-inactive'
                  "
                  (click)="onStatusClick(row['admin approval'], $event)"
                  [ngStyle]="{
                    cursor: row?.isAdminClickable ? 'pointer' : 'default',
                  }"
                >
                  {{ row["admin approval"] }}
                </span>
              </ng-container>

              <ng-container *ngSwitchCase="'teacher approval'">
                <span
                  [ngClass]="
                    row['teacher approval'] === 'Pending'
                      ? 'status-pending'
                      : row['teacher approval'] === 'Approved'
                        ? 'status-active'
                        : 'status-inactive'
                  "
                  (click)="onStatusClick(row['teacher approval'], $event)"
                  [ngStyle]="{
                    cursor: row?.isTeacherClickable ? 'pointer' : 'default',
                  }"
                >
                  {{ row["teacher approval"] }}
                </span>
              </ng-container>

              <ng-container *ngSwitchCase="'approval status'">
                <span
                  [ngClass]="
                    row['approval status'] === 'Approved'
                      ? 'status-active'
                      : row['approval status'] === 'Rejected'
                        ? 'status-inactive'
                        : 'status-pending'
                  "
                  (click)="onApprovalStatusClick(row, $event)"
                >
                  {{ row["approval status"] }}
                </span>
              </ng-container>

              <ng-container *ngSwitchCase="'attended'">
                <label
                  class="toggle-switch"
                  [class.disabled]="!isToggleEnabled(row)"
                >
                  <input
                    type="checkbox"
                    [checked]="row.attended"
                    [disabled]="!isToggleEnabled(row)"
                    (change)="onToggleChange(row, $event)"
                  />
                  <span class="slider"></span>
                </label>
              </ng-container>

              <ng-container *ngSwitchCase="'Date & time'">
                <div class="date-time-container">
                  <div class="date">{{ row["Date & time"]?.date || "-" }}</div>
                  <div class="time">{{ row["Date & time"]?.time || "" }}</div>
                </div>
              </ng-container>

              <ng-container *ngSwitchCase="'media consent'">
                <div class="d-grid gap-1">
                  <!-- <div
                    style="font-size: 10px; color: #aaa; white-space: nowrap"
                  >
                    <ng-container
                      *ngIf="row.age >= 16; else parentConsentLabel"
                    >
                      Student (16+)
                    </ng-container>
                    <ng-template #parentConsentLabel>
                      Parent/Guardian
                    </ng-template>
                  </div> -->
                  <div class="d-flex align-items-center gap-3">
                    <ng-container *ngIf="isMediaConsentEditable(row); else mediaToggleReadOnly">
                      <label
                        class="media-toggle-switch"
                        [ngClass]="[getConsentStatusClass(row['media consent']), 'csq-editable']"
                        [title]="'Click to toggle Media Consent'"
                      >
                        <input
                          type="checkbox"
                          [checked]="isConsentApproved(row['media consent'])"
                          (change)="onMediaConsentChange(row, $any($event.target).checked)"
                        />
                        <span class="slider"></span>
                      </label>
                    </ng-container>
                    <ng-template #mediaToggleReadOnly>
                      <label
                        class="media-toggle-switch static"
                        [class.approved]="isConsentApproved(row['media consent'])"
                        [class.rejected]="getConsentStatusClass(row['media consent']) === 'rejected'"
                      >
                        <input
                          type="checkbox"
                          [checked]="isConsentApproved(row['media consent'])"
                          disabled
                          readonly
                        />
                        <span class="slider"></span>
                      </label>
                    </ng-template>
                    <div
                      class="media-download-button"
                      [class.disabled]="!isConsentApproved(row['media consent'])"
                      [style.cursor]="isConsentApproved(row['media consent']) ? 'pointer' : 'default'"
                      (click)="isConsentApproved(row['media consent']) ? onDownload(row, $event, true) : $event.stopPropagation()"
                    >
                      <img src="assets/images/download-media.svg" />
                    </div>
                  </div>
                </div>
              </ng-container>

              <ng-container *ngSwitchCase="'parent consent'">
                <div
                  [ngClass]="
                    showDownloadButton(row) ? 'media-download' : 'media-pending'
                  "
                  [ngStyle]="{
                    cursor: row?.isConsentClickable ? 'pointer' : 'default',
                  }"
                >
                  <div class="time">
                    <ng-container *ngIf="showDownloadButton(row); else pending">
                      <ng-container
                        *ngIf="!row.isDownloading; else downloading"
                      >
                        <div (click)="onDownload(row, $event, true)">
                          <img
                            class="download-icon"
                            src="assets/images/download-icon.svg"
                            alt="download"
                          />
                          Download
                        </div>
                      </ng-container>

                      <ng-template #downloading>
                        <div
                          class="downloading-state"
                          (click)="$event.stopPropagation()"
                        >
                          <img
                            class="download-icon downloading-spinner"
                            src="assets/images/download-icon.svg"
                            alt="downloading"
                          />
                          Downloading...
                        </div>
                      </ng-template>
                    </ng-container>

                    <ng-template #pending> Pending </ng-template>
                  </div>
                </div>
              </ng-container>

              <ng-container *ngSwitchCase="'Partnership School/s contact'">
                <div class="date-time-container">
                  <div class="date">
                    {{ row["Partnership School/s contact"]?.name || "" }}
                  </div>
                  <div class="time">
                    {{ row["Partnership School/s contact"]?.email || "" }}
                  </div>
                </div>
              </ng-container>

              <ng-container *ngSwitchCase="'notes'">
                <div class="notes-wrapper">
                  <span class="note-text" [title]="row?.notes">
                    {{ row?.notes ? row?.notes : "-" }}
                  </span>
                  <span
                    class="edit-icon"
                    [class.active]="currentEditingRow === row"
                    [attr.data-row-id]="row.id || i"
                    (click)="onEditNotes(row, $event, i)"
                  >
                    <img src="../../../../assets/images/pencil-02.svg" />
                  </span>

                  <!-- Note Editor Dropdown with unique ID -->
                  <div
                    class="note-editor-dropdown"
                    [class.show]="currentEditingRow === row"
                    [attr.data-editor-for]="row.id || i"
                    *ngIf="currentEditingRow === row"
                  >
                    <div class="note-editor-header">
                      <h3>Edit Notes</h3>
                      <div class="cross-icon" (click)="closeNoteEditor()">
                        <img
                          src="assets/images/cross-icon.svg"
                          class="cross-icon-img"
                        />
                      </div>
                    </div>
                    <div class="note-editor-content" [class.error]="notesError">
                      <textarea
                        [(ngModel)]="editedNote"
                        (ngModelChange)="onNoteChange($event)"
                        placeholder="Enter your notes here..."
                        class="note-textarea"
                        rows="4"
                        maxlength="1000"
                      ></textarea>
                      <div class="character-count">
                        {{ editedNote.length || 0 }}/1000
                      </div>
                    </div>
                    <p *ngIf="notesError" class="notesError">
                      Please enter a note.
                    </p>
                    <div class="note-editor-actions">
                      <button class="btn-cancel" (click)="closeNoteEditor()">
                        Cancel
                      </button>
                      <button class="btn-save" (click)="saveNote()">
                        Save
                      </button>
                    </div>
                  </div>
                </div>
              </ng-container>

              <ng-container *ngSwitchCase="'colour'">
                <div class="notes-wrapper">
                  <span
                    class="color-bar"
                    [title]="row?.notes"
                    [style.backgroundColor]="row?.colour"
                    [style.padding]="'12px'"
                    [style.borderRadius]="'50px'"
                  >
                  </span>
                </div>
              </ng-container>

              <ng-container *ngSwitchDefault>
                {{ row[col] ?? "-" }}
              </ng-container>
            </ng-container>
          </ng-container>
        </td>

        <td *ngIf="actionTemplate" class="actions-cell mat-column-actions">
          <ng-container
            *ngTemplateOutlet="actionTemplate; context: { $implicit: row }"
          ></ng-container>
        </td>
      </tr>

      <tr *ngIf="safeData.length === 0">
        <td [attr.colspan]="getColspan()" class="no-data-cell">
          No data available
        </td>
      </tr>
    </tbody>

    <tbody *ngIf="loading">
      <tr>
        <td [attr.colspan]="getColspan()" class="no-data-cell">
          <span class="loading-text">Loading data...</span>
        </td>
      </tr>
    </tbody>
  </table>
</div>

<div class="pagination-container" *ngIf="!loading && safeData.length > 0">
  <div class="pagination-info">
    <span
      >Showing {{ startRecord }} to {{ endRecord }} of
      {{ totalListItem || safeData.length }} entries</span
    >
  </div>
  <div class="pagination" *ngIf="totalPages > 1">
    <button
      class="pagination-btn"
      (click)="goToPreviousPage()"
      [disabled]="!hasPreviousPage || isAnimating"
      [class.disabled]="!hasPreviousPage || isAnimating"
      title="Previous Page"
    >
      ‹
    </button>
    <ng-container *ngFor="let page of paginationDisplay">
      <button
        *ngIf="page !== '...'"
        class="pagination-btn page-number"
        [class.active]="currentPage === page"
        (click)="goToPage(+page)"
        [disabled]="isAnimating"
        [title]="'Go to page ' + page"
      >
        {{ page }}
      </button>
      <span
        *ngIf="page === '...'"
        class="pagination-btn disabled"
        style="pointer-events: none"
        >...</span
      >
    </ng-container>
    <button
      class="pagination-btn"
      (click)="goToNextPage()"
      [disabled]="!hasNextPage || isAnimating"
      [class.disabled]="!hasNextPage || isAnimating"
      title="Next Page"
    >
      ›
    </button>
  </div>
</div>
